import React, { forwardRef } from 'react';
import { Tooltip } from '@mui/material';

import getPageContext from './pageContext';
import PinguComposerChip from './PinguComposerChip';

type PinguPageContextChipProps = {
  pathname: string;
  onDismiss: () => void;
};

// The outlined page tag of chips.md 7.27: the composer card's own border, so
// it does not read as one of the user's turns.
const PinguPageContextChip = forwardRef<HTMLDivElement, PinguPageContextChipProps>(({
  pathname,
  onDismiss,
}, ref) => {
  const { label, icon: Icon } = getPageContext(pathname);

  return (
    <Tooltip title="Pingwin answers with this page in mind, so you can ask about it without explaining where you are.">
      <PinguComposerChip
        ref={ref}
        icon={<Icon />}
        label={label}
        onDelete={onDismiss}
        aria-label="Current page shared with Pingwin"
      />
    </Tooltip>
  );
});

PinguPageContextChip.displayName = 'PinguPageContextChip';

export default PinguPageContextChip;
